import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { StyledFormLabel } from '../../forms/FormLabel';
import { LyraFormInputText } from '../../adGenerator/InputText';
import { FlexBoxColumn } from '../../FlexBoxColumn';
import { KeyboardArrowRightOutlined } from '@mui/icons-material';
import { FlexBoxRow } from '../../FlexBoxRow';
import { FormStepsNextButton } from '../../styled/FormStepsNextButton';
import { useWebsiteGraderContext, WebsiteGraderStep } from 'src/components/providers/websiteGrader';
import { useSubmitUserDetailsForm } from './useSubmitUserDetailsForm';
import {alpha, Typography, useMediaQuery} from '@mui/material';
import { LyraTheme as theme } from 'src/components/theme/lyra/Theme';
import { WebSiteGraderStepper } from '../Stepper';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { PhoneRegExp } from '../../styled/FormStepOne';
import { FontWeight } from 'src/components/theme/lyra/FontWeight';

import * as Yup from 'yup';

const getValidationSchema = ({ t }: { t: TFunction }) =>
  Yup.object().shape({
    firstName: Yup.string().required(t('errors.required', { ns: 'common' })),
    lastName: Yup.string().required(t('errors.required', { ns: 'common' })),
    phone: Yup.string()
      .required(t('errors.required', { ns: 'common' }))
      .matches(PhoneRegExp, t('errors.phoneNotValid', { ns: 'common' })),
    email: Yup.string().optional(), // required ??
  });

export const WebsiteGraderUserDetailsForm = () => {
  const [queryParams] = useSearchParams();
  const { t } = useTranslation(['websiteGrader', 'common']);
  const context = useWebsiteGraderContext();
  const methods = useForm({
    defaultValues: {
      firstName: context.userDetails.firstName,
      lastName: context.userDetails.lastName,
      phone: context.userDetails.phone,
      email: context.userDetails.email ? context.userDetails.email : queryParams.get('email') ?? '',
    },
    mode: 'onChange',
    resolver: yupResolver(getValidationSchema({ t })),
  });
  const { disabled, onSubmit } = useSubmitUserDetailsForm(methods.getValues);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <FormProvider {...methods}>
      <WebSiteGraderStepper currentStep={WebsiteGraderStep.COLLECT_USER_DETAILS} />
      <FlexBoxColumn sx={{ alignSelf: 'stretch', paddingY: isMobile ? 3 : 5 }}>
        <Typography variant="h3" textAlign={'center'}>
          {t('form_collect_contact_details.heading')}
        </Typography>
      </FlexBoxColumn>
      <FlexBoxColumn sx={{ justifyContent: 'flex-start', width: '100%', gap: 3 }}>
        <FlexBoxColumn sx={{ justifyContent: 'flex-start', width: '100%', gap: 1 }}>
          <StyledFormLabel sx={{ fontWeight: FontWeight.SemiBold, color: 'grey.900' }}>
            {t('form_collect_contact_details.firstName')}
          </StyledFormLabel>
          <LyraFormInputText name="firstName" size="small" placeholder={t('form_collect_contact_details.firstName')} />
        </FlexBoxColumn>
        <FlexBoxColumn sx={{ justifyContent: 'flex-start', width: '100%', gap: 1 }}>
          <StyledFormLabel sx={{ fontWeight: FontWeight.SemiBold, color: 'grey.900' }}>
            {t('form_collect_contact_details.lastName')}
          </StyledFormLabel>
          <LyraFormInputText name="lastName" size="small" placeholder={t('form_collect_contact_details.lastName')} />
        </FlexBoxColumn>
        <FlexBoxColumn sx={{ justifyContent: 'flex-start', width: '100%', gap: 1 }}>
          <StyledFormLabel sx={{ fontWeight: FontWeight.SemiBold, color: 'grey.900' }}>
            {t('form_collect_contact_details.phone')}
          </StyledFormLabel>
          <LyraFormInputText name="phone" size="small" placeholder="Phone Number" />
        </FlexBoxColumn>
        <LyraFormInputText name="email" size="small" placeholder="Email" style={{ display: 'none' }} />
      </FlexBoxColumn>
      <FlexBoxRow sx={{ justifyContent: 'center', width: '100%', mt: isMobile ? 3 : 5 }}>
        <FormStepsNextButton
          disabled={disabled}
          onSubmit={onSubmit}
          id="website-grader-collect-user-details-next"
          color="primary"
          endIcon={<KeyboardArrowRightOutlined />}
          sx={{
            borderRadius: '12px',
            height: 40,
            padding: `${theme.spacing(1.25)} ${theme.spacing(2.5)}`,
            textTransform: 'initial',
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.88),
            },
            '&:active': {
              backgroundColor: alpha(theme.palette.primary.main, 0.80),
            },
          }}
        />
      </FlexBoxRow>
    </FormProvider>
  );
};
